import React, { useEffect } from "react"
import SEO from "../components/layout/seo"
import blockResolver from "../components/resolvers/blockResolver"
import { graphql, navigate } from 'gatsby'
import { useLanguagesOfWebsite, languageNameRewriter } from "../assets/functions"

const HlavniPage = (props) => {

  const { pageContext, data } = props
  const { strapi } = data
  const { page } = strapi
  const { Obsah } = page
  const langs = useLanguagesOfWebsite()    

  useEffect(() => {
    if(localStorage.getItem("lang")) { // if it exists in local storage
      const storageFinalPath = localStorage.getItem("lang") === "cs" ? "" : `${localStorage.getItem("lang")}` 
      const currentPath = props.path.replace("/", "")
      storageFinalPath !== currentPath && navigate(`/${localStorage.getItem("lang") === "cs" ? "" : `${localStorage.getItem("lang")}/`}`)
    } else if (typeof navigator === `undefined`) { // if no navigator is defined
      localStorage.setItem("lang", "cs")
    } else {
      const userLang = navigator.language.split("-")[0] === "cs" ? "" : navigator.language.split("-")[0]
      const matchingLang = langs.find(l => languageNameRewriter(l.lang).code === userLang)
    
      if(matchingLang) {
        const setLang = languageNameRewriter(matchingLang.lang).code
        navigate(`/${setLang === "" ? "" : `${setLang}/`}`)
        localStorage.setItem("lang", setLang === "" ? "cs" : setLang)
      } else {
        localStorage.setItem("lang", "cs")
      }
    }
  }, [langs, props])

  return(
    <>
      <SEO 
        title={pageContext.Titulek} 
        url={typeof window !== 'undefined' && window && window.location.href} 
        updated={page.updatedAt} 
        created={page.createdAt} 
        schema={true} 
        lang={pageContext.languageCode === "" ? "cs" : pageContext.languageCode}
      />
      {Obsah.map((o, i) => blockResolver(o, i))}
    </>
  )
}

export const query = graphql`
  query HlavniPageQuery($id: ID!) {
    strapi {
      page(id: $id) {
        id
        Titulek
        slug
        updatedAt
        createdAt
        Obsah {
          ... on Strapi_ComponentSpecialniSekceHeroSekce {
            ...SpecialniSekceHeroSekce
          }
          ... on Strapi_ComponentSekceTextMediaSekce {
            ...SekceTextMediaSekce
          }
          ... on Strapi_ComponentSekceKlasickaSekce {
            ...SekceKlasickaSekce
          }
          ... on Strapi_ComponentSpecialniSekceSluzby {
            ...SpecialniSekceSluzby
          }
          ... on Strapi_ComponentSpecialniSekceTymPrehled {
            ...TymPrehled
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default HlavniPage